import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const PublicLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        {/* Outlet akan merender halaman yang cocok (misal: Home atau Login) */}
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;